import { opacity70 } from '@spotify-internal/encore-foundation';
import { Box as BaseBox } from "../Box/index.mjs";
import styled, { css } from "../../styled-components.mjs";
import { cssSpacing, isSpacer } from "../../styles/layout-theme.mjs";
export var Box = styled(BaseBox).withConfig({
  displayName: "Box",
  componentId: "sc-8t9c76-0"
})(["", ""], function (_ref) {
  var $hasLeadingOrMedia = _ref.$hasLeadingOrMedia,
    $contentAlign = _ref.$contentAlign,
    $verticalGap = _ref.$verticalGap,
    $horizontalGap = _ref.$horizontalGap;
  return css(["display:grid;grid-gap:", " ", ";grid-template-columns:", ";grid-auto-rows:auto 1fr auto;&[disabled]{opacity:", ";}", ""], isSpacer($verticalGap) ? cssSpacing($verticalGap) : $verticalGap, isSpacer($horizontalGap) ? cssSpacing($horizontalGap) : $horizontalGap, $hasLeadingOrMedia ? 'auto 1fr' : '1fr', opacity70, $contentAlign && css(["margin-inline:calc(-1 * ", ");"], cssSpacing('tighter', '12px')));
});